import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../images/btn-arrow-down.webp'


const _withScopeId = n => (_pushScopeId("data-v-7c1def62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-faq" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "page-title d-block d-md-none" }, " FAQ ", -1))
const _hoisted_3 = { class: "box-content" }
const _hoisted_4 = { class: "tab-label-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "collapse-symbol" }, " Q. ", -1))
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "indicator" }, [
  /*#__PURE__*/_createElementVNode("picture", null, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-action" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "send-email-btn",
    href: "mailto:customersupport@terracycle.co.jp"
  }, "お問い合わせ"),
  /*#__PURE__*/_createElementVNode("div", { class: "send-email-text" }, " customersupport@terracycle.co.jp "),
  /*#__PURE__*/_createElementVNode("div", { class: "send-email-time" }, " 平日午前10時～午後6時（週末、祝日を除く) ")
], -1))


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function getLinkHtml(text: string, url: string) {
  return `<a class="terapak-faq-link" style="color: #4d3f3f;" href="${url}" target="_blank">${text}</a>`;
}

const tabs = [
  {
    name: 'キャンペーン',
    data: [
      {
        q: 'イオン以外の回収拠点での回収物投函も対象になりますか？',
        a: '本キャンペーンの対象は、対象店舗ページに記載のイオン83店舗のみとなります。'
      },
      {
        q: '回収物は全て同じ店舗で投函する必要がありますか？',
        a: '対象店舗ページに記載のイオン83店舗であれば、どの店舗から投函していただいても問題ありません。回収物を登録する際に、同一アカウントよりご登録をお願いします。'
      },
    ],
  },
  {
    name: '回収物',
    data: [
      {
        q: 'イオンで購入した商品のみが対象になりますか？',
        a: 'イオン以外で購入した商品でも、内側が銀色のアルミ付き紙容器であれば回収が可能です。メーカーやブランドも問いません。 '
      },
      {
        q: 'アルミ付き紙容器に付属しているキャップ、注ぎ口、ストローを取り外す必要はありますか？',
        a: 'プラスチックのキャップやストローなどは外して、投函してください。'
      },
      {
        q: 'アルミ付き紙容器の開き方を教えてください。',
        a: `${getLinkHtml('こちら', 'https://www.bellmark-schoolmilk.jp/alupa/recycle/open.pdf')}をご覧ください。`
      },
      {
        q: '牛乳パックもキャンペーン対象になりますか？',
        a: '内側が銀色のアルミ付き紙容器のみがキャンペーン対象です。'
      },
      {
        q: '紙の色は白でも茶色でも大丈夫ですか？',
        a: '紙の色を問わず、回収・リサイクルできます。'
      },
      {
        q: 'アルミ付き紙容器はリサイクルできないと聞いたことがあるのですが、本当にリサイクルできますか？',
        a: 'アルミ付き紙容器も牛乳パックのようにリサイクルできます。\n      (アルミ付き紙容器を受け入れるリサイクル工場が増えました）'
      }
    ],
  },
  {
    name: '賞品',
    data: [
      {
        q: 'チケットの種類を教えてください。',
        a: `期中（開幕日から2025年10月13日まで）にいつでも１回入場可能なチケットです。別途、来場日と訪問パビリオンの予約が必要になります。詳細は${getLinkHtml('「大阪・関西万博」のウェブサイト', 'https://www.expo2025.or.jp')}をご覧ください。`
      },
      {
        q: 'チケットの受け取り方法を教えてください。',
        a: 'キャンペーン期間が終了後、当選者にはデジタルチケットをご登録のメールアドレスに送付させていただきます。なお、当選者の発表はチケットの送付をもって代えさせていただきます。当選結果に関するご質問にはお答えできませんのでご了承ください。また、連絡先情報の不備等の事由により賞品が届けられない場合や、ご応募に関して不正な行為があった場合は、当選を取り消させていただく場合があります。'
      },
      {
        q: 'チケットの有効期限を教えてください。',
        a: `会期中（開幕日から2025年10月13日まで）にいつでも１回入場可能なチケットです。別途、来場日と訪問パビリオンの予約が必要になります。詳細は${getLinkHtml('「大阪・関西万博」のウェブサイト', 'https://www.expo2025.or.jp')}をご覧ください。`
      }
    ],
  },
  {
    name: 'テラサイクル',
    data: [
      {
        q: 'テラサイクルについて教えてください。',
        a: 'テラサイクルは、「捨てるという概念を捨てよう」というミッションのもと、現在の複雑化する廃棄物問題に対し、革新的で持続可能なソリューションの開発に取り組むソーシャルエンタープライズです。米国に本社を置き、リサイクル・リユースを推進するプラットフォームを構築・運営しています。'
      }
    ],
  }
];

return (_ctx: any,_cache: any) => {
  const _component_AppCollapse = _resolveComponent("AppCollapse")!
  const _component_AppTab = _resolveComponent("AppTab")!
  const _component_AppTabs = _resolveComponent("AppTabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_AppTabs, null, {
        trigger: _withCtx(({ index, label, active }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["faq-tab-item", { active }]),
            style: _normalizeStyle({ zIndex: tabs.length - index })
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(label), 1)
          ], 6)
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tabs, (tab) => {
            return _createVNode(_component_AppTab, {
              key: tab.name,
              label: tab.name,
              style: {}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tab.data, (faq, index) => {
                  return (_openBlock(), _createBlock(_component_AppCollapse, { key: index }, {
                    trigger: _withCtx(({ visible }) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["faq-collapse-trigger", { active: visible }])
                      }, [
                        _hoisted_5,
                        _createElementVNode("div", {
                          class: "collapse-title",
                          innerHTML: faq.q
                        }, null, 8, _hoisted_6),
                        _hoisted_7
                      ], 2)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "faq-content",
                        innerHTML: faq.a
                      }, null, 8, _hoisted_8)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1032, ["label"])
          }), 64))
        ]),
        _: 1
      })
    ]),
    _hoisted_9
  ]))
}
}

})